import packageJson from "../../package.json";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export const GET_ALL_TRIPS = () =>
  `${BaseUrl}/api/all_trips`;
export const GET_My_TRIPS = () =>
  `${BaseUrl}/api/trips/id`;
export const GET_ALL_Marshalls = () =>
  `${BaseUrl}/api/marshalls`;
export const GET_Announcements = () =>
  `${BaseUrl}/api/announcements`;
export const GET_ALL_STAFF = () =>
  `${BaseUrl}/api/staff`;
export const GET_ALL_STAFF_REQUEST = () =>
  `${BaseUrl}/api/getAllStaffRequest`;
export const ADD_USER = () =>
  `${BaseUrl}/api/users`;
export const Get_All_Fund_Type = () =>
  `${BaseUrl}/api/GetFundsType`;
export const Get_All_Fund = () =>
  `${BaseUrl}/api/getallfund`;
